import type { SuccessEnvelope as Envelope, Deleted } from '../../../core/interfaces/http/response.interface';
import type { AdministrationData } from '../../../core/interfaces/backend/usuarios/usuarios.administration.interface';
import { Injectable, inject, signal } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { EMPTY, finalize, switchMap } from 'rxjs';
import { ApiAuthService } from '../public/api-auth/api-auth.service';

@Injectable({providedIn: 'root'})
export class AdministracionService {
  private readonly http = inject(HttpClient);
  private readonly auth = inject(ApiAuthService);
  private readonly router = inject(Router);
  private readonly root = this.auth.baseUrl + '/pvt';
  readonly data = signal<AdministrationData | null>(null);
  readonly instrumentId = signal('');
  readonly loading = signal(false);
  readonly busy = signal(false);
  readonly error = signal('');
  readonly notice = signal('');
  private read() { return this.http.get<Envelope<AdministrationData>>(this.root + '/tg/usuarios/administration'); }
  private accept(data: AdministrationData): void {
    this.data.set(data);
    if (!data.instruments.some(i => i.id === this.instrumentId())) this.instrumentId.set(data.instruments[0]?.id ?? '');
  }
  load(): void {
    if (this.loading()) return;
    this.loading.set(true); this.error.set('');
    this.read().pipe(finalize(() => this.loading.set(false))).subscribe({next: r => this.accept(r.data), error: e => {this.data.set(null); this.fail(e);}});
  }
  private fail(error: HttpErrorResponse): void {
    this.error.set(error.error?.response?.message ?? 'No se pudo completar la operación. Actualice la información y revise sus permisos.');
  }
  save(path: string, body: object, done: () => void): void {
    if (this.busy() || !this.instrumentId()) return;
    this.busy.set(true); this.error.set(''); this.notice.set('');
    this.http.post(this.root + path, body).pipe(
      switchMap(() => this.auth.restore()),
      switchMap(identity => {
        if (!identity.permissions?.includes('administrar_sistema')) {
          this.data.set(null); void this.router.navigateByUrl('/dashboard'); return EMPTY;
        }
        return this.read();
      }), finalize(() => this.busy.set(false))
    ).subscribe({next: r => {this.accept(r.data); this.notice.set('Cambios guardados.'); done();}, error: e => this.fail(e)});
  }
  userName(id: string): string { return this.data()?.users.find(u => u.id === id)?.name || 'Usuario sin nombre registrado'; }
}
